import React from 'react';
import Modal from "../../components/modal/modal";

export default function ObservationTextModal({show, setter, observationText}) {
    return (
        <Modal show={show} setter={setter} name={'Notas'}>
            <div className={'mb-3'}>{observationText}</div>
        </Modal>
    )
}